import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/doubleQuotes.png'


const _withScopeId = n => (_pushScopeId("data-v-48046b76"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "brand_book_div" }
const _hoisted_2 = { id: "brand_book_left_box" }
const _hoisted_3 = { id: "brand_book_left_text_box" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  id: "box_icon",
  src: _imports_0
}, null, -1))
const _hoisted_5 = ["v-if"]
const _hoisted_6 = { id: "brand_book_right_box" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { id: "brand_book_title" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BoxWithBtn = _resolveComponent("BoxWithBtn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.ps, (pdes, pi) => {
            return (_openBlock(), _createElementBlock("div", {
              id: "box_des",
              "v-if": _ctx.item.ps,
              key: `box_p_${pi}`
            }, _toDisplayString(pdes), 9, _hoisted_5))
          }), 128))
        ]),
        (_ctx.item.link)
          ? (_openBlock(), _createBlock(_component_BoxWithBtn, {
              key: 0,
              text: _ctx.item.btnText,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onDetail(_ctx.item.link)))
            }, null, 8, ["text"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("img", {
          src: _ctx.item.img,
          id: "brand_book_img"
        }, null, 8, _hoisted_7),
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.item.title), 1)
      ])
    ]),
    _hoisted_9
  ], 64))
}